/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Directive, OnDestroy, OnInit, Self} from '@angular/core';
import {NgModel} from '@angular/forms';
import * as _ from 'lodash';
import {Subscription} from 'rxjs';

@Directive({
  standalone: true,
  selector: '[adnIntegerValidation]'
})
export class IntegerValidationDirective implements OnInit, OnDestroy {
  private sub: Subscription;

  constructor(@Self() private ngModel: NgModel) {}

  ngOnInit(): void {
    this.sub = this.ngModel.valueChanges.subscribe((inputValue: any) => {
      if (!_.isFinite(inputValue)) {
        this.ngModel.control.setValue('', {emitEvent: false});
        return;
      }
      const inputValueString = inputValue.toString(10);
      const transformedInput = inputValueString.replace(/\./g, '');
      if (transformedInput !== inputValueString) {
        const parsed = parseInt(transformedInput, 10);
        this.ngModel.control.setValue(parsed, {emitEvent: false});
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
